document.addEventListener('DOMContentLoaded', function () {
  // Hover menu desktop
  document.querySelectorAll('.hover-menu-kom').forEach(function (element) {
    element.addEventListener('click', function () {
      var link = this.getAttribute('data-link');
      if (link) {
        window.location.href = link;
      }
    });
    element.addEventListener('mouseover', function () {
      this.setAttribute('open', '');
      this.classList.add('is-open');
    });

    element.addEventListener('mouseout', function () {
      this.removeAttribute('open');
      this.classList.remove('is-open');
    });
  });
  setTimeout(function () {
    // Seleziona tutte le ancore all'interno del widget
    var anchors = document.querySelectorAll('.feedaty_widget.recensioni_con_ancora a');
    anchors.forEach(function (anchor) {
      anchor.removeAttribute('href');
    });
  }, 2000);


  // script menu secondo livello
  document.addEventListener('click', function (event) {
    if (event.target.matches('.kom-apertura-menu')) {
      event.preventDefault();

      // Trova il menu più vicino all'elemento cliccato
      var closestMenu = event.target.closest('.kom-menu-lv2');
      if (closestMenu) {
        closestMenu.classList.add('kom-is-open');
      }
    }

    if (event.target.matches('.kom-apertura-menu svg')) {
      event.preventDefault();

      // Trova il menu più vicino all'elemento cliccato
      var closestMenu = event.target.closest('.kom-menu-lv2');
      if (closestMenu) {
        closestMenu.classList.add('kom-is-open');
      }
    }

    // Gestisci anche la chiusura del menu
    if (event.target.matches('.kom-chiusura-menu span')) {
      var closestMenu = event.target.closest('.kom-menu-lv2');
      if (closestMenu) {
        closestMenu.classList.remove('kom-is-open');
      }
    }

    if (event.target.matches('.kom-chiusura-menu svg')) {
      var closestMenu = event.target.closest('.kom-menu-lv2');
      if (closestMenu) {
        closestMenu.classList.remove('kom-is-open');
      }
    }
  }, { capture: true });

});